import { render, staticRenderFns } from "./singleSelection.vue?vue&type=template&id=13535678&scoped=true&"
import script from "./singleSelection.vue?vue&type=script&lang=js&"
export * from "./singleSelection.vue?vue&type=script&lang=js&"
import style0 from "./singleSelection.vue?vue&type=style&index=0&id=13535678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13535678",
  null
  
)

export default component.exports